import { coin } from '../kit';
import { C } from '../pix';
import { defineIconKind, registerIcons } from '../store';

/** Currencies and points: silver taels, jade, cultivation (แต้มฝึกปรือ). */

defineIconKind('currency', {
  label: 'เงินตราและแต้ม',
  ids: () => ['silver', 'jade', 'cultivation'],
  name: (id) => ({ silver: 'เงินตำลึง', jade: 'หยก', cultivation: 'แต้มฝึกปรือ' })[id] ?? id,
  tint: (id) => ({ silver: '#d8dee8', jade: '#4fc49a', cultivation: '#f0d696' })[id] ?? C.gold,
  plate: 'none',
  fallback: () => ({ draw: (p) => coin(p, 16, 16, 9) }),
});

registerIcons('currency', {
  silver: (p) => {
    // A silver tael ingot on two coins.
    coin(p, 9, 23, 6, '#c8d0dc');
    coin(p, 23, 24, 5, '#c8d0dc');
    p.poly(
      [
        [4, 13],
        [28, 13],
        [24, 21],
        [8, 21],
      ],
      '#dfe5ee',
    );
    p.poly(
      [
        [9, 13],
        [12, 7],
        [20, 7],
        [23, 13],
      ],
      '#eef2f8',
    );
    p.line(13, 8, 19, 8, C.white);
  },
  jade: (p) => {
    // A pierced jade disc (bi).
    p.ell(16, 16, 12, 12, '#4fc49a');
    for (let y = 11; y < 21; y++)
      for (let x = 11; x < 21; x++) if (Math.hypot(x + 0.5 - 16, y + 0.5 - 16) < 4) p.erase(x, y);
    p.ring(16, 16, 8, 8, '#7ae0b8', -2.6, -0.4);
    p.line(16, 1, 16, 4, C.seal);
  },
  cultivation: (p) => {
    // Qi gathered into a glowing pearl over a lotus.
    for (let k = 0; k < 6; k++) {
      const a = (k * Math.PI) / 3;
      p.line(
        16 + Math.cos(a) * 7,
        13 + Math.sin(a) * 7,
        16 + Math.cos(a) * 11,
        13 + Math.sin(a) * 11,
        '#fff0a8',
      );
    }
    p.ell(16, 13, 5, 5, '#f0d696');
    p.px(14, 11, C.white).px(15, 10, C.white);
    for (const dx of [-8, -4, 0, 4, 8])
      p.poly(
        [
          [16 + dx - 2, 28],
          [16 + dx, 21 - (dx === 0 ? 3 : 0)],
          [16 + dx + 2, 28],
        ],
        dx ? '#ffb0c8' : '#ffd0e0',
      );
  },
});
